export enum SignupByInviteFormStepId {
  initial = 'initial',
  choseVerifierAccountType = 'choseVerifierAccountType',
  verifierBasicInfo = 'verifierBasicInfo',
  employerBasicInfo = 'employerBasicInfo',
  employeeVerificationPreference = 'employeeVerificationPreference',
  employeeAttestations = 'employeeAttestations',
  peoAttestations = 'peoAttestations',
  peoPayrollProviderAttestations = 'peoPayrollProviderAttestations',
  cvStaffAttestations = 'cvStaffAttestations',
  verifierAttestations = 'verifierAttestations',
  noticeToFurnishers = 'noticeToFurnishers',
  consumerAttestations = 'consumerAttestations',
  consumerReviewData = 'consumerReviewData',
  peoBasicInfo = 'peoBasicInfo',
  peoPayrollProviderBasicInfo = 'peoPayrollProviderBasicInfo',
  consumerVerificationPreference = 'consumerVerificationPreference',
  employeeSignupMethod = 'employeeSignupMethod',
  yourCompanyExistInfoBlock = 'yourCompanyExistInfoBlock',
}

export enum SignupVerifierFormStepId {
  initial = 'initial',
  emailConfirmation = 'emailConfirmation',
  relatedCompany = 'relatedCompany',
  choseVerifierAccountType = 'choseVerifierAccountType',
  verifierBasicInfo = 'verifierBasicInfo',
  verifierAttestations = 'verifierAttestations',
  noticeToFurnishersVerifier = 'noticeToFurnishersVerifierAdmin',
  yourCompanyExistInfoBlock = 'yourCompanyExistInfoBlock',
}

export enum SignupConsumerFormStepId {
  ssn = 'ssn',
  pin = 'pin',
  consumerBasicInfo = 'consumerBasicInfo',
  consumerAttestations = 'consumerAttestations',
  consumerVerificationPreference = 'consumerVerificationPreference',
  consumerReviewData = 'consumerReviewData',
}

export const verifierAdminFormFlow = [
  SignupVerifierFormStepId.initial,
  SignupVerifierFormStepId.emailConfirmation,
  SignupVerifierFormStepId.relatedCompany,
  SignupVerifierFormStepId.choseVerifierAccountType,
  SignupVerifierFormStepId.verifierBasicInfo,
  SignupVerifierFormStepId.verifierAttestations,
  SignupVerifierFormStepId.noticeToFurnishersVerifier,
  SignupVerifierFormStepId.yourCompanyExistInfoBlock,
];

export const verifierManagerFormFlow = [
  SignupVerifierFormStepId.initial,
  SignupVerifierFormStepId.emailConfirmation,
  SignupVerifierFormStepId.relatedCompany,
  SignupVerifierFormStepId.verifierAttestations,
  SignupVerifierFormStepId.noticeToFurnishersVerifier,
];
